module.exports = __webpack_public_path__ + "images/emoji/arrow_heading_down.eba71165601c2f779067.png";